import { type JSX, useState } from "react";

import { Input } from "common/components/ui/Input";

import SelectionFilter from "./SelectionFilter";

// a SelectionFilter wrapper that provides an input for custom values
export default function CustomInputFilter({
  label,
  onAddValue,
  renderTagsComponent,
}: {
  label: string;
  onAddValue: (value: string) => void;
  renderTagsComponent: (resetInputValue: () => void) => JSX.Element;
}) {
  const [inputValue, setInputValue] = useState("");

  return (
    <SelectionFilter
      label={label}
      tagsComponent={renderTagsComponent(() => setInputValue(""))}
    >
      <Input
        variant="sm"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        placeholder="Add name"
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            onAddValue(inputValue);
            setInputValue("");
          }
        }}
      />
    </SelectionFilter>
  );
}
